// Single source of truth for the deployed origin — update this when the custom domain goes live.
export const SITE_URL = 'https://findley.netlify.app';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;
